import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}><path d="M50 100A50 50 0 1050 0a50 50 0 000 100z" fill="#fff" /><path fillRule="evenodd" clipRule="evenodd" d="M39.94 39.94a10.03 10.03 0 0115.08 13.15l7.83 7.83a1.36 1.36 0 01-1.93 1.93l-7.83-7.83a10.03 10.03 0 01-13.15-15.08zm7.09-.22a7.3 7.3 0 100 14.61 7.3 7.3 0 000-14.6z" fill="#071937" /></svg>);